import React from 'react'
import { graphql } from 'gatsby'
import { Breadcrumbs, Layout } from '@components'
import BlockWrapper from '@pageBuilder/wrapper'
import { HelmetDatoCms } from 'gatsby-source-datocms'

const Page = ({ data, pageContext }) => {
  const { moduleArea, seoMetaTags } = data.page

  return (
    <Layout>
      <HelmetDatoCms defer={false} seo={seoMetaTags} />
      <BlockWrapper blocks={moduleArea} />
    </Layout>
  )
}

export const query = graphql`
  query pageById($id: String!) {
    page: datoCmsPage(id: { eq: $id }) {
      id
      path
      slug
      title
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      moduleArea {
        ... on DatoCmsAccordion {
          ...Accordion
        }
        ... on DatoCmsBanner {
          ...Banner
        }
        ... on DatoCmsButton {
          ...Button
        }
        ... on DatoCmsCardGrid {
          ...CardGrid
        }
        ... on DatoCmsCardSlider {
          ...CardSlider
        }
        ... on DatoCmsContactForm {
          ...Contact
        }
        ... on DatoCmsContent {
          ...Content
        }
        ... on DatoCmsCta {
          ...Cta
        }
        ... on DatoCmsForm {
          ...Form
        }
        ... on DatoCmsImage {
          ...Image
        }
        ... on DatoCmsSlider {
          ...Slider
        }
        ... on DatoCmsImageWithContent {
          ...ImageWithContent
        }
        ... on DatoCmsVideoWithContent {
          ...VideoWithContent
        }
        ... on DatoCmsVideo {
          ...Video
        }
      }
    }
  }
`
export default Page
